import { useSelector } from "react-redux";
import { selectSelectedCountry } from "../store/redux/country/country-slice";

const FALLBACK = {
  code: "US",
  countryName: "United States",
  currency: "USD",
  dialCode: "+1",
  flagEmoji: "🇺🇸",
  language: "en",
  symbol: "$",
};

export const useCurrency = () => {
  const country = useSelector(selectSelectedCountry) || FALLBACK;

  const formatPrice = (amount) => {
    const locale = `${country.language}-${country.code.toUpperCase()}`;

    return `${country.symbol} ${new Intl.NumberFormat(locale).format(amount)}`;
  };

  return {
    country,
    formatPrice,
  };
};
